import isModelForEditor from './isModelForEditor';

var getGlobalEditorContent = function getGlobalEditorContent(editorName) {
  var _matchingModel$getVal;

  if (window.monaco == null) {
    return null;
  }

  var models = window.monaco.editor.getModels();
  var matchingModel = models.find(function (model) {
    return isModelForEditor(model, editorName);
  });
  return (_matchingModel$getVal = matchingModel === null || matchingModel === void 0 ? void 0 : matchingModel.getValue()) !== null && _matchingModel$getVal !== void 0 ? _matchingModel$getVal : null;
};

export default getGlobalEditorContent;